import HttpClient from '../services/HttpClient';
import { STATUSANSWER, QUESTIONNAIRETOANSWER } from '../constants'


export const createAnswerQuestionnaire = (id, body) => {
    return new Promise((resolve, reject) => {
        HttpClient.post(`${QUESTIONNAIRETOANSWER}/${id}`, body).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
}


export const getfilterAnswerQuestionnaires = (dataFilter, dispatch) => {
    dispatch({
        type: 'SET_ACTIVE_LOADING',
        active: true
      })
    return new Promise((resolve, reject) => {
        let filters = `?pageNumber=${dataFilter.page}&pageSize=${dataFilter.size}`

        const keys = ['effectiveStartDate', 'effectiveEndDate', 'questionnaireNameKeyword', 'status' ];

        for (let index = 0; index < keys?.length; index++) {
          if(dataFilter[keys[index]] ){
              if(keys[index] === 'questionnaireNameKeyword' && dataFilter[keys[index]]){
                filters = `${filters}&${keys[index]}=${encodeURIComponent(dataFilter[keys[index]])}`
              }else {
                filters = `${filters}&${keys[index]}=${dataFilter[keys[index]]}`
              }
          } else {
              continue
          }
        }
        HttpClient.get(`${QUESTIONNAIRETOANSWER}${filters}`).then(response => {
            resolve(response);
            dispatch({
                type: 'SET_ACTIVE_LOADING',
                active: false
              })
        }).catch(error => {
            dispatch({
                type: 'SET_ACTIVE_LOADING',
                active: false
              })
            if (typeof error.response === 'undefined') {
                console.log('A network error occurred. ')
                reject({ error: 'technical_error', error_description: 'Occurió un problema comuniquese con el administrador.' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const getAllStatus = () => {
    return new Promise((resolve, reject) => {
        HttpClient.get(`${QUESTIONNAIRETOANSWER}${STATUSANSWER}`).then(response => {
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {
                console.log('A network error occurred. ')
                reject({ error: 'technical_error', error_description: 'Occurió un problema comuniquese con el administrador.' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const getByIdQuestionary = (id) => {
    return new Promise((resolve, reject) => {
        HttpClient.get(`${QUESTIONNAIRETOANSWER}/${id}`).then(response => {
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {
                console.log('A network error occurred. ')
                reject({ error: 'technical_error', error_description: 'Occurió un problema comuniquese con el administrador.' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}
